import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { HeaderStepper } from '../Common/HeaderStepper/HeaderStepper';
import * as Steps from './steps';
import { saveSessionEvent } from "../../../session";
import { getSessionStorageItem, setSessionStorageItem, SESSION_STORAGE_TERM_PRE_RUN_QUOTE_KEY, getBasicInfo } from '../../../sessionStorage';
import ShieldCheckIcon from '../../../icons/shield-checkmark.svg?react';

export default function PreQuote(props) {

  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => { saveSessionEvent() }, [location])

  var sessionStorageFormState = getSessionStorageItem(SESSION_STORAGE_TERM_PRE_RUN_QUOTE_KEY);

  if (props.landing && sessionStorageFormState) {
    sessionStorageFormState.currentStep = 0;
  }

  const path = location ? location.pathname.split("/").pop() : null;
  const prefill = location && location.search && location.search.toLowerCase().includes('prefill');
  const basicInfo = getBasicInfo();

  const newFormState = {
    currentStep: 0,
    pages: {
      predictiveBasicInfo: Steps.PredictiveBasicInfo.DefaultFormState(prefill, basicInfo),
      personalHistory: Steps.PersonalHistory.DefaultFormState(prefill),
      personalizingOptions: Steps.PersonalizingOptions.DefaultFormState(prefill),
      findCarriers: Steps.FindCarriers.DefaultFormState(prefill),
      basicInfo: Steps.BasicInfo.DefaultFormState(prefill, basicInfo),
    },
  };

  const initialFormState = sessionStorageFormState || newFormState;

  const [formState, setFormState] = useState(initialFormState);

  // update the formState when the url path changes the step
  useEffect(() => {
    if (!path || path === steps[formState.currentStep].path) {
      return;
    }

    const nextStep = steps.findIndex(s => s.path === path);

    if (nextStep < 0) {
      return;
    }

    const newFormState = { ...formState, currentStep: nextStep };
    setFormState(newFormState);
  }, [path]);

  const onNext = () => {
    if (formState.currentStep < steps.length - 1) {
      const newFormState = { ...formState, currentStep: formState.currentStep + 1 };
      setFormState(newFormState);
    }

    setSessionStorageItem(SESSION_STORAGE_TERM_PRE_RUN_QUOTE_KEY, newFormState);

    navigate(`/quote/term-life-insurance/multi-carrier-term`);
    window.scroll(0, 0);
  };

  const onBack = () => {
    const backStep = steps[formState.currentStep - 1];
    const newFormState = { ...formState, currentStep: formState.currentStep - 1 };

    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_TERM_PRE_RUN_QUOTE_KEY, newFormState);

    navigate(`/quote/term-life-insurance/${backStep.path}${props.landing || ''}`);
    window.scroll(0, 0);
  };

  const onFieldChange = (step, field, value) => {
    setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
  };

  const redirectToQuote = () => {
    const isDigitalTerm = location && location.pathname && location.pathname.toLowerCase().includes('digital-term');
    if (props.landing && isDigitalTerm) {
      var basicInfo = getBasicInfo();
      const bmi = basicInfo.bmi;
      if (bmi < 20 || bmi > 40) {
        onNext();
      } else {
        navigate('/quote/term-life-insurance/fully-digital');
      }
    } else {
      onNext();
    }
  }

  const steps = [
    {
      path: 'basic-info',
      progressTitle: 'Basic Information',
      component: (
        <Steps.BasicInfo
          formState={formState.pages.basicInfo}
          onFieldChange={(field, value) => onFieldChange('basicInfo', field, value)}
          onNext={redirectToQuote}
          onBack={onBack}
          hideBack={props.landing}
          ageSpecs={props.generalSpecs.specs.age}
          product="term"
          continueLabel={props.landing ? { icon: <ShieldCheckIcon className="button-icon" />, text: "Quick Quote" } : { text: "Continue" }}
          brandTheme={props.brandTheme}
        />
      ),
    },
  ];

  const currentStepObj = steps.find((s, index) => index === formState.currentStep) || steps[0];

  return (
    <div>
      <Helmet>
        <title>{`Term life insurance  - ${currentStepObj?.progressTitle}`}</title>
      </Helmet>
      <HeaderStepper
        hidden={props.landing}
        hideProgressTracker={currentStepObj.hideProgressTracker}
        stepName={currentStepObj.progressTitle}
        step={formState.currentStep + 1}
        totalSteps={steps.length}
        firstStep={true}
      >
        {currentStepObj.component}
      </HeaderStepper>
    </div>
  );
}

PreQuote.propTypes = {
  landing: PropTypes.bool,
  generalSpecs: PropTypes.object,
};
